import React from "react";
import { NavLink } from "react-router-dom";
import { Box, useTheme, Stack, Typography, Button, Paper, Chip } from "@mui/material";
import { IServiceDetailProps } from "../../interfaces/index";

const ServiceDetails: React.FC<IServiceDetailProps> = ({service}) => {
  const theme = useTheme();

  if (!service) {
    return null;
  }
  
  return (
    <Box>
      <Stack spacing={6}>
        {
          service.content.map((item, index) => (
            <Paper
              key={index}
              elevation={2}
              sx={{
                p: 4,
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: theme.shadows[4],
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "column",
                    md: index % 2 === 0 ? "row" : "row-reverse",
                  },
                  gap: 4,
                }}
              >
                <Box sx={{ width: { xs: "100%", md: "40%" } }}>
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: 2,
                      boxShadow: theme.shadows[2],
                    }}
                  />
                </Box>

                <Box sx={{ width: { xs: "100%", md: "60%" } }}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.main,
                      mb: 3,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      lineHeight: 1.8,
                      fontSize: "1.1rem",
                      mb: 3,
                    }}
                  >
                    {item.description}
                  </Typography>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.text.primary,
                        mb: 2,
                      }}
                    >
                      Benefícios:
                    </Typography>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {item.benefits.map((benefit, benefitIndex) => (
                        <Chip
                          key={benefitIndex}
                          label={benefit}
                          color="primary"
                          variant="outlined"
                          size="small"
                        />
                      ))}
                    </Box>
                  </Box>

                  <Button
                    component={NavLink}
                    to={item.link}
                    variant="contained"
                    size="medium"
                    sx={{
                      fontWeight: "bold",
                      px: 3,
                      py: 1,
                    }}
                  >
                    Solicitar Serviço
                  </Button>
                </Box>
              </Box>
            </Paper>
          ))
        }
      </Stack>
    </Box>
  );
};

export default ServiceDetails;
